/** Grow a textarea with its content (pair with a max-height class for the cap). */
export const autosizeTextarea = (el: HTMLTextAreaElement): void => {
  el.style.height = "auto";
  el.style.height = `${el.scrollHeight}px`;
};
